import { combineReducers } from 'redux';

const productMasterInitialState = {
  list: null,
  topicVo: null,
  loadStatus: 0,
};

function productMasterReducer(state = productMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_NEWUSER_PRODUCT_LIST': {
      return {
        ...state,
        loadStatus: 1,
        list: null,
        topicVo: null,
      };
    }

    case 'LOAD_NEWUSER_PRODUCT_LIST_COMPLETION': {
      const { error, topicVo } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(product => product.code);

      return {
        ...state,
        loadStatus: 2,
        list,
        topicVo,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  productMaster: productMasterReducer,
});
